var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_241_134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7237 7.27263C12.3579 8.15819 11.1758 8.60178 11.032 9.51983C10.8898 10.4379 11.8812 11.2243 13.8657 12.7956L14.3788 13.2018C14.9421 13.6486 15.2228 13.8729 15.384 14.1767C15.5469 14.4806 15.5695 14.8315 15.6163 15.5335L15.6579 16.1721C15.819 18.6419 15.9005 19.8768 16.7567 20.3025C17.6129 20.7282 18.6771 20.0636 20.8055 18.7329L21.3566 18.3884C21.9615 18.0098 22.2631 17.8197 22.6097 17.7693C22.9564 17.7173 23.3065 17.8083 24.0067 17.9903L24.6445 18.156C27.1091 18.7962 28.3414 19.1163 29.0122 18.4615C29.6846 17.8067 29.3501 16.6092 28.6828 14.2157M29.2652 10.4818C30.6275 8.40842 31.3069 7.37175 30.8667 6.53981C30.4264 5.71113 29.1543 5.63476 26.6134 5.4869L25.9548 5.4479C25.2338 5.40565 24.8733 5.38453 24.5596 5.22854C24.2459 5.07256 24.0153 4.79958 23.5543 4.25362L23.1331 3.75641C21.5109 1.83418 20.698 0.872259 19.7534 1.01362C18.8105 1.15661 18.3582 2.30702 17.4552 4.60947",
    stroke: "#FBC427",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9729 9.51636C6.92588 12.2916 3.82866 17.6001 5.43013 27C6.84962 23.0808 11.1254 19.9432 15.9038 18.432",
    stroke: "#FBC427",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_241_134",
    x: 0,
    y: -0.000488281,
    width: 36.0005,
    height: 36.0005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_241_134"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_241_134",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.fb072e0ca9bc5d76b7e21e434be9c0fe.svg";
export { ForwardRef as ReactComponent };